import { Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';

export const useAppDispatch = (): Dispatch => useDispatch<AppDispatch>();
